
import {TweenMax} from 'gsap';
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	name: 'ChatMessageMain',
	data () {
		return {
			messageProxy: '',
			autoScroll: true,
			//
            messageLimit: 150,
            isOpenEmojiContainer: false,
            isAllowSendLiveChat: true,
            blockMessageTimer: 300,
            //
            socketRequest: 'NONE',  // LOADING, COMPLETED, NONE
            verticalH: 0,
		}
	},
	computed: {
		...mapGetters({
			contentH: 'chatapp/contentH',
			globalRoom: 'chatapp/globalRoom',
		}),
		...mapState({
			cid: state => state.chatapp.cid,
			name: state => state.chatapp.name,
			pageName: state => state.chatapp.pageName,
			messageList: state => state.chatapp.messageList,
			selectedRoom: state => state.chatapp.selectedRoom,
			tempRoom: state => state.chatapp.tempRoom,
			isSocketConnect: state => state.auth.isSocketConnect,
		}),
		myItem() {
			if (this.selectedRoom) return this.selectedRoom;
			if (this.tempRoom) return this.tempRoom;
			return {};
		},
		message: {
			set(newVal) {
	        	const value = newVal.trim();
	        	const limit = this.messageLimit;
				this.messageProxy = (value.length > limit) ? str.slice(0, limit) : value;
			},
			get() {
				return this.messageProxy;
			},
		},
		myListScroll() {
			return document.getElementById('listScroll');
		},
		myInputText() {
			return this.$refs.myinput;
		},
	},
	mounted() {
        this.$signals.signal.on('scrollToBottom', this.doScroll);
        this.doScroll({anime:false});

        this.$signals.signal.on('focusInput', this.focusInputText);
	},
	methods: {
		...mapMutations({
			setSelectedRoom: 'chatapp/setSelectedRoom',
			setMessageList: 'chatapp/setMessageList',
			resetTempRoom: 'chatapp/resetTempRoom',
			resetSelectedRoom: 'chatapp/resetSelectedRoom',
			appendMessageList: 'chatapp/appendMessageList',
		}),
        focusInputText(data) {
        	// console.log('focusInputText', data);
        	if (data.instance == 1) {
	        	this.socketRequest = 'NONE';
	    		TweenMax.delayedCall(.1, () => {
	    			this.myInputText.focus();
	    		});
        	}
        },
		doScroll({anime}) {
			if (!this.autoScroll) return;

			const obj = this.myListScroll;

			TweenMax.killTweensOf(obj);
			if (anime) {
				TweenMax.set(obj, {alpha:1});
				TweenMax.to(obj, .5, {scrollTop: obj.scrollHeight});
			} else {
				TweenMax.set(obj, {alpha: 0});
	            TweenMax.delayedCall(.2, () => {
					TweenMax.to(obj, .3, {alpha: 1});
                    TweenMax.set(obj, {scrollTop: obj.scrollHeight});
	            });
			}
		},
        // resizeWindow() {
        	// this.winH = window.innerHeight;
            // this.boxH = window.innerHeight - 230;
        // },
		clickSendButton() {
			if(!this.isSocketConnect) return console.log('socket disconnect');

			if (!this.message) {
				console.log('invalid message'); return;
			}
			if (this.message.length < 1) {
				console.log('message is empty'); return;
			}
			if (!this.isAllowSendLiveChat) {
				console.log('not allow send message'); return;
			}

            this.isAllowSendLiveChat = false;
            setTimeout(() => {
                this.isAllowSendLiveChat = true;
            }, this.blockMessageTimer);

			// 1. CREATE NEW ROOM IF <TEMP ROOM> STATUS
			if (this.tempRoom) {
				const friendEmail = this.tempRoom.email;
				this.$socket.emit('addFriend', {clientCid: this.cid, friendEmail}, (res) => {
					console.log('CB addFriend', res);

					// 1.1 SUCCESS OR FAILED, MUST RESET <TEMP ROOM>
					this.resetTempRoom();
					
					// 1.2 RETURN IF RESULT FAILED
					if (!res.isok) return;

					// 1.3 CONVERT <TEMP ROOM> TO <SELECTED ROOM>
					this.setSelectedRoom(res.item);

					// 1.4  SEND MESSAGE
					this.doSendMessage();
				});
			} else {
				// 2. SEND MESSAGE
				this.doSendMessage();
			}
		},
		doSendMessage() {
            this.message = this.sanitizeText(this.message);

			const data = {
				clientCid: this.cid,
				message: this.message,
				roomCid: this.selectedRoom.roomCid
			};
			// 1. SEND MESSAGE
			if(this.message){
				this.$socket.emit('sendMessage', data, (res) => {
					console.log('CB sendMessage', res)

					// 2. EMPTY MESSAGE AND CLOSE EMOJI
					this.message = '';
					this.isOpenEmojiContainer = false;
				});
			}
		},
		handleScroll() {
			// console.log('this.myListScroll.clientHeight', this.myListScroll.clientHeight);
			// console.log('this.myListScroll.scrollTop', this.myListScroll.scrollTop);
			// console.log('this.myListScroll.scrollHeight', this.myListScroll.scrollHeight);
			if (this.myListScroll.scrollTop <= 0) {
				this.loadMoreMessages();
			}

			// DETECT BOTTOM POTION, ADJUST AREA HEIGHT 300
			this.autoScroll =  (this.myListScroll.scrollTop > (this.myListScroll.scrollHeight - this.myListScroll.clientHeight - 300));
		},	
		loadMoreMessages() {
			if (this.socketRequest == 'LOADING') {
				console.log('please wait, socket requesting...'); return;
			}

			let messageCid = '';
			if (this.messageList && this.messageList.length > 0) {
				messageCid = this.messageList[0].cid;
			}
			
			this.verticalH = this.myListScroll.scrollHeight;

			console.log('last messageCid >>', messageCid);
			const roomCid = this.selectedRoom?.roomCid;
			this.socketRequest = 'LOADING';
			this.$socket.emit('getMoreMessages', {clientCid: this.cid, roomCid, messageCid}, (data) => {
				console.log('CB getMoreMessages', data);
				if (!data.isok) {
					this.socketRequest = 'COMPLETED';
					return;
				}
				
				if (data.items && data.items.length > 0) {
					TweenMax.killTweensOf(this.myListScroll);
					this.appendMessageList(data.items);
					TweenMax.set(this.myListScroll, {alpha: 0})
		            TweenMax.delayedCall(.1, () => {
						this.socketRequest = 'COMPLETED';
						const scrollTop = this.myListScroll.scrollHeight - this.verticalH;
		            	TweenMax.set(this.myListScroll, {alpha:1, scrollTop});
		            });
				}
			});
		},
        limitInputText() {
        	if (this.isAllowSendLiveChat) {
        		this.message = this.$refs.myinput.value;
        	} else {
        		this.$refs.myinput.value = '';
        	}
        },
        onToggleEmojiContainer(){
            this.isOpenEmojiContainer = !this.isOpenEmojiContainer;
            if (this.isOpenEmojiContainer) {
            	const obj = this.$refs.mEmoji;
            	TweenMax.killTweensOf(obj);
            	TweenMax.set(obj, {alpha: 0});
            	TweenMax.to(obj, .3, {alpha: 1});
            }
        },
        addEmojiToText(item){
        	console.log('addEmojiToText', item);
        	if (this.message.length > this.messageLimit -1) {
        		this.$refs.myinput.focus();
        		return;
        	}

        	const myinput = this.$refs.myinput;
            var startPos = myinput.selectionStart,
                endPos = myinput.selectionEnd,
                cursorPos = startPos,
				tmpStr = this.message;

            this.message = tmpStr.substring(0, startPos) + item + tmpStr.substring(endPos, tmpStr.length);
            setTimeout(() => {
                cursorPos += item.length;
                myinput.focus();
                myinput.selectionStart = myinput.selectionEnd = cursorPos;
            }, 10);
        },
        clickBackButton(){
        	this.resetTempRoom();
        	this.resetSelectedRoom();
        	this.setMessageList([]);
        },
        convertTextToUrl(text) {
		    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
		    return text.replace(urlRegex, function(url, b, c){
		        const url2 = (c == 'www.') ?  `http://${ url }` : url;
		        return `<a href="${ url2 }" target="_blank" class="text-blue-500"><u class="break-all">${ url }</u></a>`;
		    });
		},
	},
}
